import { render, staticRenderFns } from "./PageCompanySettings.vue?vue&type=template&id=d04f5a06&"
import script from "./PageCompanySettings.vue?vue&type=script&lang=js&"
export * from "./PageCompanySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports